<template>
	<div id="app">

		<router-view />

		<div class="about" :class="{visible: about}">
			<!-- <img src="@/assets/title.png" class="title"> -->
			<div class="text">
				Сладкий, кислый, горький или соленый.
				<br>
				Какой вкус вам нравится больше? Выбирайте любой открывайте для себя идеальные сочетания вкусов.
				<br>
				Вместе с Aqua Minerale мы создали карту вкусов,<br>которая подарит вам новые гастрономические впечатления.
			</div>
		</div>

		<div class="show-about" :class="{visible: isWhite || about}" @click="toggleAbout">
			<img src="@/assets/burger1.png" v-if="!about">
			<img src="@/assets/burger2.png" v-else>
			<span>О проекте</span>
		</div>

		<div class="show-about black" :class="{visible: !isWhite && !about}" @click="toggleAbout">
			<img src="@/assets/burger1_b.png" v-if="!about">
			<img src="@/assets/burger2_b.png" v-else>
			<span>О проекте</span>
		</div>


		<uiNavigator :slide="curSlide" />


		<Shares />


		<div class="video-overlay" :class="{visible: video}" @click="closeVideo">

			<iframe v-if="video === 'cherry'" width="80%" height="60%" src="https://www.youtube.com/embed/QSFoP7Cl9GI" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

			<iframe v-if="video === 'lime'" width="80%" height="60%" src="https://www.youtube.com/embed/_QgTyw3MF8M" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

			<iframe v-if="video === 'lemon'" width="80%" height="60%" src="https://www.youtube.com/embed/jTamWlz1cjs" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

			<iframe v-if="video === 'apple'" width="80%" height="60%" src="https://www.youtube.com/embed/AI9AXkWrbfE" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

		</div>

	</div>
</template>

<script>
import Events from '@/events'
import Shares from '@/components/Shares'
import uiNavigator from '@/components/uiNavigator'

export default {
	name: 'App',
	components: {
		Shares,
		uiNavigator,
	},
	data() {
		return {
			isWhite: true,
			about: false,
			video: null,
			curSlide: 0,
		}
	},
	created() {
		Events.$on('change-slide', (index) => {
			if (window.gtag) gtag('event', `home slide to ${index}`)
			this.curSlide = index
			if (index === 0) this.isWhite = true
			else this.isWhite = false
		})
		Events.$on('open-video', (type) => {
			console.log(type)
			this.video = type
			if (window.gtag) gtag('event', `open video ${type}`)
		})

		let hash = window.location.hash
		if (hash && hash.length > 0) {
			let types = ['cherry', 'lemon', 'lime', 'apple']
			let clean = hash.slice(1)
			if (types.includes(clean)) this.video = clean
		}
		
	},
	methods: {
		toggleAbout() {
			this.about = !this.about
			if (window.gtag) {
				if (this.about) gtag('event', `open about`)
				else gtag('event', `close about`)
			}
		},
		closeVideo() {
			if (window.gtag) gtag('event', `close video ${this.video}`)
			this.video = null
		},
	}
}
</script>


<style lang="less">
@import "./assets/app.less";

body {
	padding: 0;
	margin: 0;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	font-family: 'Muller';
	font-weight: 500;
}

#app {
	width: 100vw;
	height: 100vh;
}

.show-about {
	position: absolute;
	top: 20px;
	right: 30px;
	color: #fff;
	cursor: pointer;
	opacity: 0;
	pointer-events: none;
	text-transform: uppercase;

	&.black {
		color: #000;
	}

	img {
		margin-right: 10px;
		transform: translateY(5px);
	}

	&.visible {
		opacity: 1;
		pointer-events: all;
	}

}

.about {
	position: absolute;
	background: #000;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	opacity: 0;
	pointer-events: none;
	transition: all 500ms ease;
	background-image: url("./assets/about_blur.png");
	background-size: cover;
	background-position: center top;

	&.visible {
		opacity: 1;
		pointer-events: all;
	}

	.text {
		color: #fff;
		font-size: 20px;
		line-height: 28px;
		text-align: center;
		max-width: 600px;
		// margin-top: -70px;
		margin-top: 20px;
	}

	.title {
		max-width: 670px;
		display: block;
	}
}

.video-overlay {
	position: fixed;
	background: #000;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	opacity: 0;
	pointer-events: none;
	transition: all 500ms ease;
	background-size: cover;
	background-position: center top;

	&.visible {
		opacity: 1;
		pointer-events: all;
	}

}


@media only screen and (max-width: 1000px) {

.about {
	.title {
		width: 90%;
	}

	.text {
		font-size: 16px;
		line-height: 22px;
		padding: 0 20px;
	}
}

.show-about {
	display: none;

	// top: 10px;
	// right: 10px;

	// span {
	// 	display: none;
	// }

	// img {
	// 	padding: 10px;
	// 	margin-right: 0;
	// }
}


}
</style>